import React from 'react';
import { Collapse, Grid } from '@arco-design/web-react';
import { t } from '@bay-email/core';
import { TextStyle, useFocusIdx } from '@bay-email/editor';
import { Padding } from '@extensions/AttributePanel/components/attributes/Padding';
import { ContainerBackgroundColor } from '@extensions/AttributePanel/components/attributes/ContainerBackgroundColor';
import { BorderWidth } from '@extensions/AttributePanel/components/attributes/BorderWidth';
import { BorderStyle } from '@extensions/AttributePanel/components/attributes/BorderStyle';
import { BorderColor } from '@extensions/AttributePanel/components/attributes/BorderColor';
import { InputWithUnitField } from '@extensions/components/Form';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';
import { pixelAdapter } from '../../adapter';

export function Signature() {
  const { focusIdx } = useFocusIdx();

  return (
    <CollapseWrapper 
        isChevron
        iconPosition='right'
        defaultActiveKey={['1', '2']} 
        style={{ padding: 0 }}
      >
      {/* Disclaimer moved into the Signature block skeleton template */}

      <Collapse.Item name='1' header={t('Dimension')} contentStyle={{ padding: 0 }}>
        <div className='p-3'>
          <Padding showResetAll />
        </div>
      </Collapse.Item>

      <Collapse.Item name='2' header={t('Styling')} contentStyle={{ padding: 0 }}>
        <div className='p-3'>
          <Grid.Row gutter={16}>
            <Grid.Col span={12}>
              <ContainerBackgroundColor title={t('Background color')} />
            </Grid.Col>
          </Grid.Row>

          {/* Border Controls (matches the Button block) */}
          <TextStyle
            variation='strong'
            style={{ marginBottom: '12px', marginTop: '16px', display: 'block' }}
          >
            {t('Border')}
          </TextStyle>
          <Grid.Row gutter={16}>
            <Grid.Col span={10}>
              <BorderColor secondary />
            </Grid.Col>
            <Grid.Col span={8}>
              <BorderWidth
                secondary
                config={pixelAdapter}
                label={t('Thickness (px)')}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <BorderStyle secondary />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row gutter={16}>
            <Grid.Col span={12}>
              <InputWithUnitField
                label={`${t('Border Radius')} (px)`}
                name={`${focusIdx}.attributes.border-radius`}
                config={pixelAdapter}
              />
            </Grid.Col>
          </Grid.Row>
        </div>
      </Collapse.Item>
    </CollapseWrapper>
  );
}
